import React, { createContext, useState } from "react";

export const HotelContext = createContext();

export const HotelProvider = ({ children }) => {
  // state used for capture the step number
  const [currentStep, setCurrentStep] = useState(0); // Track the current step

  const [formData, setFormData] = useState({
    vendorId: "",
    status: "pending",
    itemStatus: "pending",
    overview: {
      basicDetails: {
        hotelName: "",
        hotelDescription: "",
        hotelWebsite: "",
        hotelRating: "",
        hotelChain: "",
        hotelBrand: "",
        selectedTags: {
          types: [],
          views: [],
          styles: {
            traditional: [],
            modern: [],
            eclectic: [],
            cultural: [],
          },
        },
      },
      additionalDetails: {
        isSustainable: false,
        hotelBuiltYear: "",
        lastRenovatedYear: "",
        selectedEventTypes: [],
        awards: [{ name: "", year: "" }],
        tradeLicenseFile: null,
        brochureFiles: [],
      },
      locationDetails: {
        addressLine1: "",
        addressLine2: "",
        city: "",
        area: "",
        poBox: "",
        country: "United Arab Emirates",
        mapLink: "",
        parkingAvailable: false,
        valetParking: false,
        lat: null,
        lng: null,
        accessibilityFeatures: {
          airportShuttle: false,
          metro: false,
          taxi: false,
          bus: false,
        },
      },
    },

    accommodation: {
      accommodations: 0,
    },
    pricing: {
      basePrice: "",
      mentionSeasons: false,
      highDemandMonths: [],
      midDemandMonths: [],
      lowDemandMonths: [],
    },
    offerPackage: [],
    amenities: {
      businessFeaturesIcons: {},
      roomFeaturesIcons: {},
      roomFeatures: {},
      businessFeatures: {},
      recreationalFeatures: {},
      recreationalFeaturesIcons: {},
    },
    photoVideo: {
      images: [],
      videos: [],
      videoLinks: [],
      coverPhoto: "",
    },
    errors: {
      overview: false,
      accommodation: false,
      pricing: false,
      photoVideo: false,
    },
  });

  return (
    <HotelContext.Provider
      value={{ formData, setFormData, currentStep, setCurrentStep }}
    >
      {children}
    </HotelContext.Provider>
  );
};
